import makeStyles from "@material-ui/core/styles/makeStyles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  snackbars: {
    maxWidth: "90%",
    position: "fixed",
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    left: "50%",
    right: "auto",
    transform: "translateX(-50%)",
    zIndex: theme.zIndex.snackbar,
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%",
      width: "100%",
      paddingLeft: 16,
      paddingRight: 16
    }
  },
  snackbar: {
    position: "relative",
    marginBottom: 24,
    "&:last-child": {
      marginBottom: 0
    },
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%",
      marginBottom: 16
    }
  },
  snackMessage: {
    [theme.breakpoints.down("xs")]: {
      wordBreak: "break-word"
    }
  }
}));
